import renderElement from './element';

export default renderElement.bind(null, 'ul');




// WEBPACK FOOTER //
// ../~/idom-util/src/ul.js